import { CommandJob } from "app/components/build/Show/lib/types";

interface Props {
  jobs: CommandJob[];
}

export function Jobs({ jobs }: Props) {
  const passCount = jobs.filter((job) => job.passed).length;
  const totalCount = jobs.length;

  return (
    <span className="text-charcoal-300">
      {passCount} of {totalCount} passed
    </span>
  );
}
